<template>
    <v-row no-gutters>
        <v-col cols="12" class="px-4 pt-4 pb-0">
            <h3 class="pa-0">{{title}}</h3>
        </v-col>
        <v-col cols="12">
            <v-list v-if="loading">
                <v-skeleton-loader ref="skeleton" type="list-item-avatar" class="mx-auto"></v-skeleton-loader>
            </v-list>
            <v-list v-else>
                <div v-for="(item, index) in items" :key="index">
                    <v-list-item @click="clickListener(item)">
                        <v-list-item-avatar size="35px" color="transparent">
                            <v-icon  v-if="item.icon" class="outline-primary primary--text">{{item.icon}}</v-icon>
                            <img v-else :src="item.image">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.title"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                     <v-divider v-if="divider" class="mx-6"></v-divider>
                </div>
            </v-list>
        </v-col>
    </v-row>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        clickListener(item) {
            this.$emit("click", item);
        }
    },
    props: {
        items: Array,
        loading: Boolean,
        title: String,
        divider: Boolean
    }
}
</script>
<style lang="scss" scoped>
.v-divider {
    position: relative;
    height: 1px;
    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to right, transparent 50%, rgba(0, 0, 0, 0.5) 50%);
        background-size: 10px 100%;
        height: 1px;
    }
    border-style: none;
}
</style>